var symphony = symphony || {};

;(function() {

	symphony.defaultModal = function() {

		$('.js-modal').magnificPopup({
			disableOn: 700,
			type: 'iframe',
			mainClass: 'mfp-fade',
			removalDelay: 160,
			preloader: false,
			fixedContentPos: false
		});

	};


})();